import { create } from 'zustand';

interface AccountStore {
  accountId: string | undefined;
  accountName: string | undefined;
  setAccountId: (accountId: string | undefined) => void;
  setAccountName: (accountName: string | undefined) => void;
}

/** Global Salesforce Account context the LWC host pushes via embedding props. */
export const useAccountStore = create<AccountStore>(set => ({
  accountId: undefined,
  accountName: undefined,
  setAccountId: accountId => {
    set({ accountId });
  },
  setAccountName: accountName => {
    set({ accountName });
  },
}));
